export default {
  materials: {
    '319': [],
    '321': [],
    '322': [],
    '1603': [],
  },
  system: {
    id: '317',
    name: 'Моторизация Amigo',
  },
  model: null,
  material: null,
  calculation: null,
  count: 1,
};
